const hasPositiveQuantity = (value) => {
  if (typeof value !== 'number' && typeof value !== 'string') return false
  if (typeof value === 'string' && value.trim() === '') return false

  const quantity = Number(value)
  return Number.isSafeInteger(quantity) && quantity > 0
}

export const filterVisibleOrderItems = (items) =>
  (Array.isArray(items) ? items : [])
    .filter((item) => item && hasPositiveQuantity(item.quantity))
    .map((item) => ({
      ...item,
      extra: (Array.isArray(item.extra) ? item.extra : [])
        .filter((extraItem) =>
          extraItem && hasPositiveQuantity(extraItem.quantity)
        ),
    }))
